module.exports = __webpack_public_path__ + "img/404.585ad4fe.png";